import React from 'react';
import Disclaimer from 'components/common/general/Disclaimer';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';
import { toJS } from 'mobx';
import { HELP_ME_DECIDE_HELPER } from 'global/utils/HelpMeDecideHelper';
import { createStyles } from '../../globalStyles';
import { createStyles as createCustomStyles } from './styles';

const HelpMeDecidePage = observer((): JSX.Element => {
  const {
    domainStore: { domainHeader },
  } = useRootStore();

  const convertedDomain = toJS(domainHeader);

  const classes = createStyles();
  const customClasses = createCustomStyles({ background: convertedDomain.properties?.eStoreBackground || '' });

  return (
    <div className={customClasses.background}>
      <div className={classes.narrowPageWrapper}>
        {HELP_ME_DECIDE_HELPER[convertedDomain.id].content || <></>}
        <Disclaimer />
      </div>
    </div>
  );
});

export default HelpMeDecidePage;
